/**
 * Shared language configuration for the application
 * Used by both the header language selector and Settings page
 * 
 * flagCode uses ISO 3166-1 alpha-2 country codes for flag-icons library
 * @see https://flagicons.lipis.dev/
 */

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flagCode: 'gb' },
  { code: 'pt', name: 'Português', flagCode: 'pt' },
  { code: 'fr', name: 'Français', flagCode: 'fr' },
  { code: 'es', name: 'Español', flagCode: 'es' },
  { code: 'de', name: 'Deutsch', flagCode: 'de' },
  { code: 'it', name: 'Italiano', flagCode: 'it' },
  { code: 'pt-BR', name: 'Português (BR)', flagCode: 'br' },
  { code: 'zh-CN', name: '中文(简体)', flagCode: 'cn' },
  { code: 'ja', name: '日本語', flagCode: 'jp' },
  { code: 'ko', name: '한국어', flagCode: 'kr' },
  { code: 'ar', name: 'العربية', flagCode: 'sa' },
  { code: 'tr', name: 'Türkçe', flagCode: 'tr' },
  { code: 'ru', name: 'Русский', flagCode: 'ru' },
  { code: 'th', name: 'ไทย', flagCode: 'th' },
  { code: 'hi', name: 'हिन्दी', flagCode: 'in' },
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];
export type LanguageCode = SupportedLanguage['code'];
